import type { UseCoreResult } from './types'

export type { UseCoreResult } from './types'

type CreateCoreOptions = {
  store: unknown
  router: unknown
  i18n: unknown
}

let core: UseCoreResult | null = null

export function createCore ({ store, router, i18n }: CreateCoreOptions): UseCoreResult {
  const _i18n = i18n as any
  if (core && !process.env.JEST_WORKER_ID) {
    throw new Error('createCore has already been called')
  }

  const _store = store as any

  const t = (...args: [string, ...unknown[]]): string => {
    if (args.length > 1) {
      return _i18n.global.tc(...args)
    }
    return _i18n.global.t(...args)
  }

  const tc = (...args: [string, ...unknown[]]): string => {
    return _i18n.global.tc(...args)
  }

  const tm = (...args: [string, ...unknown[]]): unknown => {
    return _i18n.global.tm(...args)
  }

  const apiCall = (...args: unknown[]): Promise<unknown> => {
    const firstArg = args[0] as { url: string }
    if (firstArg.url.match(/^\/loyalty-card-service\//)) {
      return _store.dispatch('api/callLoyalty', ...args)
    } else if (firstArg.url.match(/^\/hint-and-walkthrough\//)) {
      return _store.dispatch('api/callHintAndWalkthrough', ...args)
    } else {
      return _store.dispatch('api/call', ...args)
    }
  }

  core = {
    store: store as UseCoreResult['store'],
    router: router as UseCoreResult['router'],
    i18n: i18n as UseCoreResult['i18n'],
    t,
    tc,
    tm,
    apiCall,
  }

  return core
}

export function useCore (): UseCoreResult {
  if (!core) {
    throw new Error('useCore called before createCore')
  }

  return core
}
